import { Box, Text } from "@mantine/core";
import React, { useState, useEffect } from "react";

export default function Empty({ title, text }) {
  return (
    <Box style={{ textAlign: "center" }} my={100}>
      <Text size="md" fw={600} mb="xs">
        {title}
      </Text>
      <Text color="dimmed" size="sm">
        {text}
      </Text>
    </Box>
  );
}
